import { Typography } from "@mui/material";
import React from "react";
import SideDrawer from "../../components/SideDrawer";

function AccountSection() {
  return (
    <SideDrawer>
      <Typography
        variant="h1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: 900,
          fontSize: { xs: "30px", sm: "40px" },
          lineHeight: "50px",
          textAlign: { xs: "center", md: "left" },
          color: "#8102FF",
          textTransform: "uppercase",
        }}
      >
        Accounts
      </Typography>
    </SideDrawer>
  );
}

export default AccountSection;
